import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import React, { useState } from 'react';
import AppLink from '../components/common/AppLink/AppLink';
import StickyTableHeader from '../components/common/StickyTableHeader';
import ListHeader, { AddButton } from '../components/listHeader/ListHeader';
import ListBottomBar from '../components/common/ListBottomBar/ListBottomBar';
import { useSearchTerm } from '../hooks/useSearchTerm';
import { useSyncPageParams } from '../hooks/useSyncPageParams';
import { useClampPage } from '../hooks/useClampPage';
import { ROUTE_PATHS } from '../routes/Routes';
import { useGetAllUserRoles } from '../services/react-query/user_roles';
import {
  defaultContainerStyling,
  listPageTableRowStyling,
  listPageTableWrapperStyles,
} from '../styles/sxStyling';
import { UserRole } from '../types/UserRole';
import { Loading } from '../uikit';
import TierModal from '../components/userRoles/TierModal';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useGetAllBillingTiers } from '../services/react-query/billing_tiers';

const UserRolesList: React.FC = () => {
  const navigate = useNavigate();
  const { currentPage, setCurrentPage } = useSyncPageParams();
  const [showModal, setShowModal] = useState<boolean>(false);
  const { data: billingTiers } = useGetAllBillingTiers({});
  const { data, isLoading: isGetAllUserRoleLoading } = useGetAllUserRoles({
    params: {
      page: currentPage,
      search: useSearchTerm(),
    },
  });

  const userRoles = data?.data;
  const meta = data?.meta;
  const headerCells = ['Name', 'Description'];

  useClampPage(currentPage, meta?.total_pages, setCurrentPage);

  if (isGetAllUserRoleLoading) {
    return <Loading />;
  }

  const handleNew = () => {
    if (!billingTiers) return;

    if (billingTiers.data.length === 1) {
      newWithTier(billingTiers.data[0].uuid);
    } else {
      setShowModal(true);
    }
  };

  const newWithTier = (tierUuid: string) => {
    navigate(`./new?${qs.stringify({ tierUuid })}`);
  };

  const tableItems =
    userRoles &&
    userRoles.map((userRole: UserRole) => (
      <TableRow key={userRole.uuid} sx={{ ...listPageTableRowStyling }}>
        <TableCell>
          <AppLink to={`/${ROUTE_PATHS.USER_ROLES}/${userRole.uuid}`}>{userRole.name}</AppLink>
        </TableCell>
        <TableCell>{userRole.description}</TableCell>
      </TableRow>
    ));

  return (
    <Box>
      <ListHeader title="User Permissions" rightActions={<AddButton onAdd={handleNew} />} />
      <Box sx={listPageTableWrapperStyles}>
        <TableContainer sx={defaultContainerStyling}>
          <Table>
            <StickyTableHeader cells={headerCells} />
            <TableBody>{tableItems}</TableBody>
          </Table>
        </TableContainer>
        <ListBottomBar page={currentPage} meta={meta} onChange={(_e, v) => setCurrentPage(v)} />
      </Box>
      <TierModal isOpen={showModal} onCancel={() => setShowModal(false)} onCreate={newWithTier} />
    </Box>
  );
};

export default UserRolesList;
